import * as React from 'react';
import styled from 'styled-components';
import {NewsletterData} from 'epic-ue-shared';
import {SectionWrapper} from 'epic-ue-components';
import {CenteredEngagementCard} from 'epic-ue-newsletter';

export interface NewsletterSectionProps extends NewsletterData {
    bgMedia: {
        image: string;
    };
    buttonLabel: string;
    inputPlaceholder: string;
}

const Section = styled.section`
    position: relative;

    .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-formControl {
        border: 1px solid #fff;
    }
    .engagement-section {
        margin: 0 auto;
        max-width: 800px;
    }
    .row.email {
        margin-bottom: 15px;
        input {
            height: 40px;
        }
    }
    .card.overlay {
        background-color: rgba(0, 0, 0, 0.35);
        .card-content {
            border-radius: 12px;
        }
    }
`;

const NewsletterSection: React.FC<NewsletterSectionProps> = props => {
    if (!props) return null;

    return (
        <Section>
            <SectionWrapper>
                <CenteredEngagementCard newsletterData={props} disableIndustrySelect marketoLeadParams={{eOSSourceOptIn: true}} epicOptIn />
            </SectionWrapper>
        </Section>
    );
};

export default NewsletterSection;
